export default __webpack_public_path__ + "static/media/avatar_7.9f6168c2.svg";